import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import NewsForm from "components/form/NewsForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "News creata con successo",
        errorMsg: "Errore nella creazione della news",
        navigateTo: { link: "/news" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovaNews() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi News</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <NewsForm />

                <ButtonSave />
            </SaveContextProvider>
        </>
    );
}

export default NuovaNews;
